import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import CameraTitleComponent from '../../Camera/CameraTitleComponent';

import RefreshIcon from '../../../res/svg/RefreshIcon';
import {
  StyledBMXCameraContainer,
  StyledReloadIconButton,
  StyledUserMessage,
} from './styledComponents';

const BMXCameraComponent = ({
  showCameraTitle,
  buildingId,
  buildingName,
  cameraName,
  id,
  userMessage,
  shouldShowReload,
  reloadPage,
}) => {
  const { t } = useTransl();
  return (
    <StyledBMXCameraContainer>
      {showCameraTitle ? (
        <CameraTitleComponent
          buildingId={buildingId}
          buildingName={buildingName}
          cameraName={cameraName}
        />
      ) : null}
      <video style={{ height: '100%' }} id={id} autoPlay muted />
      {userMessage ? (
        <StyledUserMessage>{userMessage}</StyledUserMessage>
      ) : null}
      {shouldShowReload ? (
        <StyledReloadIconButton
          onClick={() => reloadPage()}
          aria-label={t('actions.refresh')}
          size="large"
        >
          <RefreshIcon />
        </StyledReloadIconButton>
      ) : null}
    </StyledBMXCameraContainer>
  );
};

BMXCameraComponent.defaultProps = {
  userMessage: null,
};

BMXCameraComponent.propTypes = {
  reloadPage: PropTypes.func.isRequired,
  showCameraTitle: PropTypes.bool.isRequired,
  shouldShowReload: PropTypes.bool.isRequired,
  buildingId: PropTypes.number.isRequired,
  buildingName: PropTypes.string.isRequired,
  cameraName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  userMessage: PropTypes.string,
};

export default BMXCameraComponent;
